module.exports = __webpack_public_path__ + "static/media/logo_white.f5b83ab4.svg";